import { RpcError } from '../../../shared/api/rpc-client';

const WOOVI_PAYMENT_SPLIT_AMOUNT_ERROR =
  'o valor total do split de pagamento não pode ser igual ou maior que o valor da cobrança menos a taxa esperada';

function isWooviPaymentSplitAmountError(error: unknown): boolean {
  return (
    error instanceof RpcError &&
    error.message.toLowerCase().includes(WOOVI_PAYMENT_SPLIT_AMOUNT_ERROR)
  );
}

export function resolveTipCheckoutSubmitError(
  error: unknown,
  t: (key: string) => string,
): string | null {
  if (!error) {
    return null;
  }

  if (isWooviPaymentSplitAmountError(error)) {
    return t('tipsCheckout.amountTooLow');
  }

  return t('login.networkError');
}
